import React from "react";

export default function Button({

    children,

    onClick,

    type = "button",

    loading = false,

    loadingText = "در حال ارسال...",

    disabled = false,

    className = ""

}) {

    return (

        <button

            type={type}

            onClick={onClick}

            disabled={loading || disabled}

            className={`

                w-full

                h-12

                rounded-2xl

                bg-primary

                text-white

                font-medium

                shadow-[0_10px_20px_rgba(248,130,37,0.22)]

                transition-all duration-200

                hover:-translate-y-0.5

                hover:bg-[#e97116]

                active:translate-y-0

                active:scale-[0.98]

                focus:outline-none

                focus:ring-4

                focus:ring-primary/25

                disabled:translate-y-0

                disabled:opacity-50

                disabled:cursor-not-allowed

                ${className}

            `}

        >

            <span aria-live="polite">{loading ? loadingText : children}</span>

        </button>

    );

}
